import { createSelector } from 'reselect';
import { aiBeautyChatSelector } from 'ai/selectors/testTarget/aiBeautyChat/aiBeautyChatSelector';

const featuresSelector = createSelector(aiBeautyChatSelector, aiBeautyChat => aiBeautyChat.features);

export { featuresSelector };
